import styles from './Footer.module.css'
import {paymentSystemsImg} from "../../../assets/images/images.ts";
import {Icon} from "@/ui/General/Icon/Icon.tsx";
import {cn} from "@/utils/cn.ts";
import {Phone} from "@/widgets/Phone/Phone.tsx";

export const Footer: React.FC = () => {
    return (
        <footer style={{marginTop: "auto"}}>
            <div className={cn(styles.footerContainer, styles.topContainer)}>
                <div className={styles.topContent}>
                    <div className={styles.block}>
                        <div className={styles.title}>Клиентам</div>
                        <div className={styles.line}></div>
                        <ul className={styles.linkList}>
                            <li className={styles.linkItem}><a href="/deliveryandpayment">Доставка и оплата</a></li>
                            <li className={styles.linkItem}><a href="/refund">Возврат и обмен</a></li>
                            <li className={styles.linkItem}><a href="/guarantee">Гарантия</a></li>
                            <li className={styles.linkItem}><a href="/privacy">Конфиденциальность</a></li>
                            <li className={styles.linkItem}><a href="javascript:jivo_api.open()">Обратная связь</a></li>
                            <li className={styles.linkItem}><a href="/bonus">Бонусная программа</a></li>
                        </ul>
                    </div>
                    <div className={styles.block}>
                        <div className={styles.title}>Компания</div>
                        <div className={styles.line}></div>
                        <ul className={styles.linkList}>
                            <li className={styles.linkItem}><a href="/for_suppliers">Поставщикам</a></li>
                            <li className={styles.linkItem}><a href="/contacts">Контакты</a></li>
                            <li className={styles.linkItem}><a href="/vacancy">Вакансии</a></li>
                            <li className={styles.linkItem}><a href="/about">О нас</a></li>
                            <li className={styles.linkItem}><a href="/assets/offer.pdf">Оферта</a></li>
                            <li className={styles.linkItem}><a href="/for_owners">Владельцам пунктов выдачи</a></li>
                        </ul>
                    </div>
                    <div className={styles.blockFeedback}>
                        <div className={styles.title}>Связаться с нами</div>
                        <div className={styles.line}></div>
                        <div className={styles.phoneWrapper}>
                            <Phone showIcon={false} numberClassName={styles.phone} />
                        </div>
                        <div className={styles.contacts}>
                            <a href='https://telegram.me/podzamenu'><Icon name='telegram' width={39} height={35} className={styles.socialIcon}/></a>
                            <a className="waconvert" href='https://api.whatsapp.com/send?phone=79841576629'><Icon name='whatsapp' width={39} height={35} className={styles.socialIcon}/></a>
                            <a href='mailto:shop.podzamenu@yandex.ru'><Icon name='mail' width={42} height={35} className={styles.socialIcon}/></a>
                        </div>
                    </div>
                </div>
            </div>
            <div className={cn(styles.footerContainer, styles.bottomContainer)}>
                <div className={styles.bottomContent}>
                    <div className={styles.legalInfo}>
                        <div>КОЛЕСНИЧЕНКО АЛЕКСАНДР НИКОЛАЕВИЧ (ИП)</div>
                        <div>ИНН 490801599803</div>
                        <div>ОГРНИП 321253600087011</div>
                        <div>Все права защищены ©2024</div>
                    </div>
                    <img className={styles.paymentSystems} src={paymentSystemsImg} alt="Методы платежа"/>
                </div>
            </div>
        </footer>
    );
};
